import { useContext, useEffect, useMemo, useState } from "react";
import SeleccionContext from "../../../../context/Seleccion/SeleccionContext";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import UndoIcon from "@mui/icons-material/Undo";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ColumnVisibilityMenu from "../../../ui/ColumnVisibilityMenu";
import TableSearchInput from "../../../ui/TableSearchInput";
import IconBloquear from "../../../ui/icons-seleccion/IconBloquear";
import IconDescarte from "../../../ui/icons-seleccion/IconDescarte";
import IconDescargaNomina from "../../../ui/icons-seleccion/IconDescargaNomina";
import IconCargando from "../../../ui/icons-seleccion/IconCargando";
import FiltroGenerico from "../../../ui/kit-modal/FiltroGenerico";
import InputFiltro from "../../../ui/kit-modal/Filtros-kit/InputFiltro";
import StateFiltro from "../../../ui/kit-modal/Filtros-kit/StateFiltro";
import ModalGenerico from "../../../ui/kit-modal/ModalGenerico";
import ModalDescartarBloquear from "../../../ui/kit-modal/bloquearDescartar/ModalDescartarBloquear";
import ModalAvanzarProceso from "../../../ui/kit-modal/avanzarProceso/ModalAvanzarProceso";
import ModalNoProcesadoSeleccion from "../../../ui/kit-modal/noProcesado/ModalNoProcesadoSeleccion";
import Tooltip from "../../../ui/kit-mdtw/tooltip/Tooltip";
import BotonExcelMasterRex from "../../../ui/excelMasterRex/BotonExcelMasterRex";
import { downloadFichaLegacyByRuts } from "../../../../services/fichaLegacyService";
import { IEstadosExcel, IFiltrosExcel } from "../../../../interfaces/ISeleccion";
import { OPCIONES_FILTRO_CEDULA } from "../../../../utils/filtroCedula";
import {
  ESTADO_ASISTE,
  ESTADO_CITADO,
  ESTADO_INGRESO_EFECTIVO,
  OPCIONES_FILTRO_GESTION_INGRESO,
  anteriorEstadoGestionIngreso,
  estadosAConsultar,
  siguienteEstadoGestionIngreso,
} from "../../../../utils/estadosGestionIngreso";
import "./gestion-ingreso.css";

// La nota queda en la bitácora (BusPerHistoria."Comentario", varchar 500) junto
// a un prefijo con el estado de origen y el usuario: se limita para que entre.
const MAX_NOTA_RETROCESO = 350;

interface IActionMassive {
  tipoProceso: string;
  /** Rótulo de la etapa de Selección a la que vuelve un Citado al retroceder. */
  etapaSeleccion: string;
  listadoSeleccionado: string[];
  setListadoSeleccionado: Function;
  localStorageFilter: string;
  formFilter: any;
  setFormFilter: Function;
  listRefresh: Function;
  columnDefinitions: readonly { key: string; label: string }[];
  visibleColumnKeys: string[];
  setVisibleColumnKeys: (keys: string[]) => void;
  isSavingColumns?: boolean;
  isColumnsSynchronized?: boolean | null;
  searchValue?: string;
  onSearch?: (term: string) => void;
}

const restoreBodyScroll = (): void => {
  const body = document.querySelector("body");
  if (body) body.style.overflowY = "auto";
};

const ActionMassive = (props: IActionMassive) => {
  const {
    tipoProceso,
    etapaSeleccion,
    listadoSeleccionado,
    setListadoSeleccionado,
    localStorageFilter,
    formFilter,
    setFormFilter,
    listRefresh,
    columnDefinitions,
    visibleColumnKeys,
    setVisibleColumnKeys,
    isSavingColumns,
    isColumnsSynchronized,
    searchValue,
    onSearch,
  } = props;
  const {
    token,
    listaCandidatoGestionIngreso,
    listaNoProcesadosSeleccion,
    postGenerarExcel,
    putAvanzarProceso,
    putRetrocederProceso,
  } = useContext(SeleccionContext);
  const [candidates, setCandidates] = useState<string[]>([]);
  const [isOpenModalAvanzar, setIsOpenModalAvanzar] = useState<boolean>(false);
  const [isOpenModalRetroceder, setIsOpenModalRetroceder] = useState<boolean>(false);
  const [notaRetroceso, setNotaRetroceso] = useState<string>("");
  const [isOpenModalNoProcesado, setIsOpenModalNoProcesado] = useState<boolean>(false);
  const [isOpenModalBloquear, setIsOpenModalBloquear] = useState<boolean>(false);
  const [isOpenModalDescartar, setIsOpenModalDescartar] = useState<boolean>(false);
  const [openModalFiltro, setOpenModalFiltro] = useState<boolean>(false);
  const [dataObject, setDataObject] = useState<boolean | undefined>(undefined);
  const [isLoadingExcel, setIsLoadingExcel] = useState<boolean | undefined>(undefined);
  const [isLoadingFicha, setIsLoadingFicha] = useState<boolean>(false);

  const seleccionados: any[] = useMemo(
    () =>
      (listaCandidatoGestionIngreso || []).filter((item: any) =>
        listadoSeleccionado.includes(item.personaDNI)
      ),
    [listaCandidatoGestionIngreso, listadoSeleccionado]
  );
  const buttonEnabled: boolean = seleccionados.length > 0;
  // Ingresado es la última etapa: si todo lo marcado ya está ahí, no hay a dónde avanzar.
  const puedeAvanzar: boolean = seleccionados.some(
    ({ busPerEstado }: any) => busPerEstado !== ESTADO_INGRESO_EFECTIVO
  );

  // Estados para la descarga: los mismos que muestra la tabla según el filtro.
  const filtroGuardado: any = (() => {
    try {
      return JSON.parse(localStorage.getItem(localStorageFilter) || "null");
    } catch {
      return null;
    }
  })();
  const estadosVisibles: string[] = estadosAConsultar(
    (filtroGuardado ?? formFilter)?.estadoIngreso
  );
  const estadosExcel: IEstadosExcel = {
    porValidar: false,
    preseleccionado: false,
    validado: false,
    citado: estadosVisibles.includes(ESTADO_CITADO),
    asiste: estadosVisibles.includes(ESTADO_ASISTE),
    ingresoEfectivo: estadosVisibles.includes(ESTADO_INGRESO_EFECTIVO),
  };
  const filtrosExcel: IFiltrosExcel = {
    busPerIdList: [],
    reclutador: [],
    estadoRegistro: [],
    nombre: [],
    rut: [],
    proceso: [],
    cliente: [],
    tipoProceso: [tipoProceso],
    fechaPostulacion: [],
    fechaValidacion: [],
    fechaPreseleccion: [],
    confirmaEntrevista: null,
    transporteTeamwork: null,
    entrevistaRealizada: null,
  };

  useEffect(() => {
    if (localStorage.getItem(localStorageFilter)) {
      const copyStorage: any = localStorage.getItem(localStorageFilter);
      const hasFilters = Object.entries(JSON.parse(copyStorage)).some(
        ([key, value]: any) => key !== "tipoProceso" && Array.isArray(value) && value.length > 0
      );
      setDataObject(hasFilters);
    }
  }, [localStorage.getItem(localStorageFilter)]);

  const handleAvanzar = async (): Promise<void> => {
    setIsOpenModalAvanzar(false);
    restoreBodyScroll();
    if (!token) return;
    await putAvanzarProceso({
      token,
      procesos: candidates,
      setIsOpenModalNoProcesado,
    });
    setListadoSeleccionado([]);
    listRefresh();
  };

  const cerrarModalRetroceder = (): void => {
    setIsOpenModalRetroceder(false);
    setNotaRetroceso("");
    restoreBodyScroll();
  };

  const handleRetroceder = async (): Promise<void> => {
    const motivo: string = notaRetroceso.trim();
    if (!motivo) return;
    cerrarModalRetroceder();
    if (!token) return;
    await putRetrocederProceso({
      token,
      procesos: candidates.map((busPerId: string) => ({ busPerId, motivo })),
      setIsOpenModalNoProcesado,
    });
    setListadoSeleccionado([]);
    listRefresh();
  };

  const handleDownloadFichas = async (): Promise<void> => {
    if (isLoadingFicha || !buttonEnabled) return;
    setIsLoadingFicha(true);
    try {
      await downloadFichaLegacyByRuts(
        seleccionados.map((item: any) => ({
          rut: item.personaDNI,
          busquedaId: item.busquedaId,
          busPerId: item.busPerId,
        }))
      );
    } catch (error) {
      console.log("ERROR DESCARGANDO FICHAS", error);
    } finally {
      setIsLoadingFicha(false);
    }
  };

  const handleClickNomina = async (): Promise<void> => {
    if (!token) return;
    if (filtroGuardado) {
      filtrosExcel.proceso = filtroGuardado.proceso?.map((valor: any) => parseInt(valor)) ?? [];
      filtrosExcel.cliente = [...(filtroGuardado.cliente ?? [])];
      filtrosExcel.fechaPostulacion = [...(filtroGuardado.fechaPostulacion ?? [])];
      filtrosExcel.reclutador = [...(filtroGuardado.reclutador ?? [])];
      filtrosExcel.rut = [...(filtroGuardado.rut ?? [])];
      filtrosExcel.nombre = [...(filtroGuardado.nombre ?? [])];
    }
    filtrosExcel.busPerIdList = seleccionados
      .map((item: any) => item.busPerId)
      .filter(Boolean);
    await postGenerarExcel({
      token,
      estadosExcel,
      filtrosExcel,
      setIsLoading: setIsLoadingExcel,
    });
  };

  return (
    <>
      <section className="container-actions w-100">
        <div className="content-button-masive">
          <button
            className={`button-navegation ${puedeAvanzar ? "naranjo" : "disabled"}`}
            onClick={() => setIsOpenModalAvanzar(true)}
            disabled={!puedeAvanzar}
          >
            Avanzar Estado
            <ArrowForwardIcon />
          </button>
        </div>

        {onSearch && (
          <div
            style={{
              flex: "1 1 auto",
              minWidth: 0,
              display: "flex",
              margin: "0 16px",
            }}
          >
            <TableSearchInput
              value={searchValue ?? ""}
              onSearch={onSearch}
              placeholder="Buscar en la tabla…"
              height={40}
            />
          </div>
        )}

        <div className="content-actions-masive">
          <BotonExcelMasterRex
            listadoSeleccionado={listadoSeleccionado}
            estadosExcel={estadosExcel}
            filtrosExcel={filtrosExcel}
            localStorageFilter={localStorageFilter}
          />

          <Tooltip text="Retroceder Estado">
            <button
              className={`button-actions ${buttonEnabled ? "active-reasignar" : "disabled"}`}
              disabled={!buttonEnabled}
              onClick={() => setIsOpenModalRetroceder(true)}
            >
              <UndoIcon style={{ fontSize: 20, color: buttonEnabled ? "#0065DD" : undefined }} />
            </button>
          </Tooltip>
          <Tooltip text="Bloquear">
            <button
              className={`button-actions ${buttonEnabled ? "active-block" : "disabled"}`}
              disabled={!buttonEnabled}
              onClick={() => setIsOpenModalBloquear(true)}
            >
              <IconBloquear fill={"#BE2A2A"} disabled={!buttonEnabled} />
            </button>
          </Tooltip>
          <Tooltip text="Descartar">
            <button
              className={`button-actions ${buttonEnabled ? "active-block" : "disabled"}`}
              disabled={!buttonEnabled}
              onClick={() => setIsOpenModalDescartar(true)}
            >
              <IconDescarte fill={"#BE2A2A"} disabled={!buttonEnabled} />
            </button>
          </Tooltip>

          <Tooltip text={isLoadingFicha ? "Generando fichas…" : "Descargar Ficha"}>
            <button
              className={`button-actions ${buttonEnabled && !isLoadingFicha ? "active-rojo" : "disabled"}`}
              disabled={!buttonEnabled || isLoadingFicha}
              onClick={handleDownloadFichas}
            >
              {isLoadingFicha ? (
                <IconCargando fill="#D32F2F" />
              ) : (
                <PictureAsPdfIcon style={{ fontSize: 20 }} />
              )}
            </button>
          </Tooltip>

          <Tooltip text="Descargar Nómina">
            <button
              className={`button-actions ${isLoadingExcel ? "disabled file" : "active-file"}`}
              onClick={() => handleClickNomina()}
            >
              {isLoadingExcel ? (
                <IconCargando fill="#327a30" />
              ) : (
                <IconDescargaNomina fill="#327a30" />
              )}
            </button>
          </Tooltip>

          <ColumnVisibilityMenu
            variant="icon"
            columns={columnDefinitions as { key: string; label: string }[]}
            visibleKeys={visibleColumnKeys}
            onChange={setVisibleColumnKeys}
            isSaving={isSavingColumns}
            isSynchronized={isColumnsSynchronized}
          />

          <Tooltip text="Filtros">
            <button
              type="button"
              aria-label="Filtros"
              className="button-actions active-azul"
              onClick={() => setOpenModalFiltro((prev) => !prev)}
            >
              {dataObject ? (
                <FilterAltIcon style={{ fontSize: 24 }} />
              ) : (
                <FilterAltOutlinedIcon style={{ fontSize: 24 }} />
              )}
            </button>
          </Tooltip>
        </div>
      </section>

      {openModalFiltro && (
        <FiltroGenerico
          inline
          title="Filtros"
          localStorageFilter={localStorageFilter}
          onBack={() => setOpenModalFiltro(false)}
          onValueChange={setFormFilter}
          onPropertyChange={formFilter}
        >
          <StateFiltro
            layer="ESTADO"
            listState={OPCIONES_FILTRO_GESTION_INGRESO}
            localStorageFilter={localStorageFilter}
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="estadoIngreso"
          />
          <InputFiltro
            layer="NOMBRE"
            typeFilter="text"
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="nombre"
          />
          <InputFiltro
            layer="RUT"
            typeFilter="rut"
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="rut"
          />
          <InputFiltro
            layer="ID PROCESO"
            typeFilter="text"
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="proceso"
          />
          <InputFiltro
            layer="CLIENTE"
            typeFilter="text"
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="cliente"
          />
          <InputFiltro
            layer="FECHA POSTULACIÓN"
            typeFilter="date"
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="fechaPostulacion"
          />
          <InputFiltro
            layer="RECLUTADOR"
            typeFilter="text"
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="reclutador"
          />
          <StateFiltro
            layer="VALIDACIÓN"
            listState={OPCIONES_FILTRO_CEDULA}
            localStorageFilter={localStorageFilter}
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="cedula"
          />
        </FiltroGenerico>
      )}

      {isOpenModalAvanzar && (
        <ModalGenerico
          title="CONFIRMAR MOVIMIENTO"
          width="w-70"
          subtitle="Estás por avanzar de estado la siguiente selección: "
          onChangeBack={() => {
            setIsOpenModalAvanzar(false);
            restoreBodyScroll();
          }}
          onChangeGo={() => handleAvanzar()}
          buttonBackText="Cancelar"
          buttonGoText="Aceptar"
        >
          <ModalAvanzarProceso
            listCandidate={listadoSeleccionado}
            listData={listaCandidatoGestionIngreso}
            setCandidates={setCandidates}
            destinoPorItem={({ busPerEstado }: any) =>
              siguienteEstadoGestionIngreso(busPerEstado) ?? "Sin cambio (ya ingresado)"
            }
          />
        </ModalGenerico>
      )}

      {isOpenModalRetroceder && (
        <ModalGenerico
          title="CONFIRMAR RETROCESO"
          width="w-70"
          subtitle="Estás por retroceder de estado la siguiente selección: "
          onChangeBack={cerrarModalRetroceder}
          onChangeGo={() => handleRetroceder()}
          buttonBackText="Cancelar"
          buttonGoText="Aceptar"
          buttonGoDisable={notaRetroceso.trim().length > 0}
          buttonDisabledTooltipText="Escribe una nota para continuar"
        >
          <ModalAvanzarProceso
            listCandidate={listadoSeleccionado}
            listData={listaCandidatoGestionIngreso}
            setCandidates={setCandidates}
            destinoPorItem={({ busPerEstado }: any) =>
              anteriorEstadoGestionIngreso(busPerEstado, etapaSeleccion)
            }
            mensaje="Al confirmar, la lista volverá a la etapa anterior correspondiente."
          />
          <div className="gi-nota">
            <label className="gi-nota-label" htmlFor="gi-nota-retroceso">
              Nota (obligatoria)
            </label>
            <textarea
              id="gi-nota-retroceso"
              className="gi-nota-textarea"
              value={notaRetroceso}
              maxLength={MAX_NOTA_RETROCESO}
              placeholder="¿Por qué vuelve atrás? Queda registrado en el historial del candidato."
              onChange={(event) => setNotaRetroceso(event.target.value)}
            />
            <div className="gi-nota-ayuda">
              <span>Se guarda en la bitácora junto al movimiento.</span>
              <span>{notaRetroceso.length}/{MAX_NOTA_RETROCESO}</span>
            </div>
          </div>
        </ModalGenerico>
      )}

      {isOpenModalNoProcesado && (
        <ModalGenerico
          title="Candidatos No Enviados"
          iconTitle="danger"
          width="w-70"
          subtitle="Los siguiente candidatos no pudieron ser procesados:"
          onChangeBack={() => {
            setIsOpenModalNoProcesado(false);
            restoreBodyScroll();
          }}
          buttonBackText="Cerrar"
        >
          <ModalNoProcesadoSeleccion list={listaNoProcesadosSeleccion ?? []} />
        </ModalGenerico>
      )}

      {isOpenModalBloquear && (
        <ModalGenerico
          title="BLOQUEO DE CANDIDATOS"
          width="w-70"
          subtitle="Estás por bloquear la siguiente selección de candidatos:"
          onChangeBack={() => {
            setIsOpenModalBloquear(false);
            restoreBodyScroll();
          }}
        >
          <ModalDescartarBloquear
            typeExclusion="bloqueo"
            getListRefresh={listRefresh}
            setListadoSeleccionado={setListadoSeleccionado}
            listSelect={listaCandidatoGestionIngreso ?? []}
            localStorageFilter={localStorageFilter}
            formFilter={formFilter}
            onChangeBack={() => {
              setIsOpenModalBloquear(false);
              restoreBodyScroll();
            }}
            list={listadoSeleccionado}
          />
        </ModalGenerico>
      )}

      {isOpenModalDescartar && (
        <ModalGenerico
          title="DESCARTE DE CANDIDATOS"
          width="w-70"
          subtitle="Estás por descartar la siguiente selección de candidatos:"
          onChangeBack={() => {
            setIsOpenModalDescartar(false);
            restoreBodyScroll();
          }}
        >
          <ModalDescartarBloquear
            typeExclusion="descarte"
            getListRefresh={listRefresh}
            setListadoSeleccionado={setListadoSeleccionado}
            listSelect={listaCandidatoGestionIngreso ?? []}
            localStorageFilter={localStorageFilter}
            formFilter={formFilter}
            onChangeBack={() => {
              setIsOpenModalDescartar(false);
              restoreBodyScroll();
            }}
            list={listadoSeleccionado}
          />
        </ModalGenerico>
      )}
    </>
  );
};

export default ActionMassive;
